module.exports = __webpack_public_path__ + "img/multiSlectedEle.1df6e0ab.svg";